<template>
  <div id="job-manage">
    <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
    <table class="job-header">
      <thead>
        <tr>
          <th>BROJ</th>
          <th>IME</th>
          <th>LOKACIJA</th>
          <th>GENERALNI OPIS</th>
          <th>ZAHTJEVI</th>
          <th>OČEKIVANJA</th>
          <th>TIP POSLA</th>
          <th>SPONZOR</th>
          <th>LINK</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="job" v-for="(job, index) in jobs" v-bind:key="job.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ job.name }}</td>
          <td>{{ job.location }}</td>
          <td>{{ job.generalDescription }}</td>
          <td>{{ job.requirements }}</td>
          <td>{{ job.expectations }}</td>
          <td>{{ job.jobType }}</td>
          <td>{{ job.company.name }}</td>
          <td>{{ job.link }}</td>
          <td>
            <button type="button" v-on:click="openAddEditModal(job)">UREDI</button>
          </td>
          <td>
            <button type="button" v-on:click="deleteJob(job)">IZBRIŠI</button>
          </td>
        </tr>
      </tbody>
    </table>
    <AddEditJobModal
      v-if="modalVisible"
      v-on:cancel="resetJob"
      v-on:save="saveJob"
      v-bind:job="jobForModal"
      v-bind:jobTypes="jobTypes"
      v-bind:companies="companies"
    />
  </div>
</template>

<script>
import AddEditJobModal from '@/components/admin/jobs/AddEditJobModal.vue';

export default {
  name: 'JobManage',
  data() {
    return {
      jobs: [],
      jobForModal: {},
      modalVisible: false,
      jobTypes: [],
      companies: [],
    };
  },
  components: {
    AddEditJobModal,
  },
  methods: {
    openAddEditModal: function(job) {
      this.jobForModal = job ? job : { isAdd: true };
      this.modalVisible = true;
    },
    saveJob: function(jobToSave) {
      if (jobToSave.id) {
        this.$axios
          .post(`${this.$API_URL}/companies/edit-job`, jobToSave)
          .catch(() => {
            this.axios.get(`${this.$API_URL}/companies/get-job/${jobToSave.id}`).then(response =>
              this.jobs.splice(
                this.jobs.findIndex(job => job.id === jobToSave.id),
                1,
                response.data,
              ),
            );

            alert('Edit posla neuspješan. Nevaljan unos ili zabranjen pristup.');
          })
          .catch(() => {
            alert('Pokušan je edit nepostojećeg posla!');
          });
      } else {
        this.$axios
          .post(`${this.$API_URL}/companies/add-job`, jobToSave)
          .then(response => {
            jobToSave.id = response.data;
            this.jobs.push(jobToSave);
          })
          .catch(_ => {
            alert(
              'Dodavanje posla neuspješno. Prekoračenje dozvoljenih duljina teksta ili prekoračenje broja poslova.',
            );
          });
      }
      this.modalVisible = false;
    },
    resetJob: function(jobToReset) {
      if (jobToReset.id) {
        this.$axios.get(`${this.$API_URL}/companies/get-job/${jobToReset.id}`).then(response => {
          this.jobs.splice(
            this.jobs.findIndex(job => job.id === jobToReset.id),
            1,
            response.data,
          );
        });
      }
      this.modalVisible = false;
    },
    deleteJob: function(jobToDelete) {
      if (confirm(`Jeste li sigurni da želite izbrisati posao: ${jobToDelete.name}?`)) {
        this.$axios
          .delete(`${this.$API_URL}/companies/delete-job/${jobToDelete.id}`)
          .then(() => {
            this.jobs.splice(
              this.jobs.findIndex(job => job.id === jobToDelete.id),
              1,
            );
          })
          .catch(() => {
            alert('Brisanje neuspješno. Nevaljan unos ili zabranjen pristup.');
          });
      }
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/companies/get-all-jobs`).then(response => {
      this.jobs = response.data;
    });
    this.$axios.get(`${this.$API_URL}/companies/get-job-types`).then(response => {
      this.jobTypes = response.data;
    });
    this.$axios.get(`${this.$API_URL}/companies/all-sponsors`).then(response => {
      this.companies = response.data;
    });
  },
};
</script>

<style scoped>
#job-manage {
  color: white;
}

button {
  padding: 6px;
}
</style>
